
define('text!views/pages/cash/deposit/playOkLimitsReached.html',[],function () { return '<div class="pad-big center color-green">\n    <img width="160" data-bind="image: image" />\n\n    <div class="gutter-top" data-bind="html: message"></div>\n</div>';});

